import React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StraightIcon from '@mui/icons-material/Straight';
import CloseIcon from '@mui/icons-material/Close'; 

// Map page names to route paths



const pages = [
  { label: 'Home', path: '/' },

  {
    label: (
      <>
        Biography & <br /> Professional Ventures
      </>
    ),
    path: '/biography'
  },

  {
    label: (
      <>
        Awards <br />  &Honours
      </>
    ),
    path: '/awards'
  },

  {
    label: (
      <>
        Thought <br /> Leadership
      </>
    ),
    path: '/thought-leadership'
  },

  {
    label: (
      <>
        Photo & Media <br /> Gallery
      </>
    ),
    path: '/media-gallery'
  },

  { label: 'Events', path: '/events' },

  { label: 'Contact', path: '/contact' }
];

const biographySubItems = [
  { label: 'LIFE STORY', hash: '#life-story' },
  { label: 'TIMELINE OF KEY EVENTS', hash: '#timeline' },
  { label: 'PERSONAL INSIGHTS & TESTIMONIALS', hash: '#testimonials' },
  { label: 'WOCKHARDT LIMITED', hash: '#wockhardt' },
  { label: 'PEACE & HUMANITARIAN INITIATIVES', hash: '#peace' },
  { label: 'I AM PEACEKEEPER MOVEMENT', hash: '#peacekeeper' },
  { label: 'GLOBAL JUSTICE LOVE & PEACE SUMMIT', hash: '#summit' },
  { label: 'BILLIONAIRES FOR PEACE', hash: '#billionaires' },
];


function Header() {

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {

    setAnchorElNav(event.currentTarget);

  };

  const handleCloseNavMenu = () => {

    setAnchorElNav(null);

  };

  const [anchorElBiography, setAnchorElBiography] = React.useState(null);

  const handleBiographyOpen = (event) => {
    setAnchorElBiography(event.currentTarget);
  };

  const handleBiographyClose = () => {
    setAnchorElBiography(null);
  }
  const location = useLocation();

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [biographyOpen, setBiographyOpen] = React.useState(false);

  const [isScrolled, setIsScrolled] = React.useState(false);

React.useEffect(() => {
  const handleScroll = () => {
    setIsScrolled(window.scrollY > 50);
  };
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    setDrawerOpen(open);
  };

  const handleBiographyToggle = () => {
    setBiographyOpen(!biographyOpen);
  };

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  //scroll to top 
  const [showScrollTop, setShowScrollTop] = React.useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

    const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  return (
    <AppBar position="sticky" 
    className={`mainHeader ${isScrolled ? "scrolled" : ""}`} elevation={0} top={0} sx={{ zIndex: (theme) => theme.zIndex.drawer}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          {/* Mobile Menu */}
          {/* Mobile Drawer Toggle Button */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              //  onClick={toggleDrawer(false)}
              onKeyDown={toggleDrawer(false)}
              color="inherit"
              className='menuIcon'
            >
              <MenuIcon />
            </IconButton>

            <Drawer
              anchor="left"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
              className='mobileDrawer'
              ModalProps={{ 
                keepMounted: true, 
                sx: { 
                  zIndex: (theme) => theme.zIndex.drawer + 900, 
                } 
              }}
            >
              <Box
                sx={{ width: 250 }}
                role="presentation"
              >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1}}>
                <IconButton onClick={toggleDrawer(false)} className='exitButton'>
                  <CloseIcon />
                </IconButton>
              </Box>
                <List className='sidebarList'>
                  {pages.map(({ label, path }) => {
                    if (path === '/biography') {
                      return (
                        <React.Fragment key={path}>
                          <ListItemButton onClick={handleBiographyToggle}>
                            <ListItemText primary="Biography & Professional Ventures" />
                            {biographyOpen ? <ExpandLess /> : <ExpandMore />}
                          </ListItemButton>
                          <Collapse in={biographyOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              {biographySubItems.map(({ label, hash }) => (
                                <ListItemButton
                                  key={hash}
                                  component={Link}
                                  to={`/biography${hash}`}
                                  sx={{ pl: 4 }}
                                >
                                  <ListItemText primary={label} />
                                </ListItemButton>
                              ))}
                            </List>
                          </Collapse>
                        </React.Fragment>
                      );
                    }

                    return (
                      <ListItem key={path} disablePadding>
                        <ListItemButton component={NavLink} to={path}>
                          <ListItemText
                            primary={
                              typeof label === 'string'
                                ? label
                                : path === '/biography'
                                  ? 'Biography & Professional Ventures'
                                  : path === '/awards'
                                    ? 'Awards & Honours'
                                    : path === '/thought-leadership'
                                      ? 'Thought Leadership'
                                      : path === '/media-gallery'
                                        ? 'Photo & Media Gallery'
                                        : ''
                            }
                          />

                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
                <Divider />
              </Box>
            </Drawer>
          </Box>


          {/* Logo or Title */}
          <Typography

            variant="h6"

            component={Link}

            to="/"

            sx={{

              mr: 2,

              display: { xs: 'flex', md: 'none' },

              flexGrow: 1,

              fontWeight: 700,

              textDecoration: 'none',

              color: 'inherit',

              fontFamily: 'monospace',

              letterSpacing: '.2rem',

            }}
          >


          </Typography>

          {/* Desktop Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} className="headerTitles">

            {pages.map(({ label, path }) => {
              if (path === '/biography') {
                return (
                  <Button
                    key={path}
                    onClick={handleBiographyOpen}
                    sx={{ my: 2, color: 'white', display: 'block' }}
                    className='dropdownHeadernav'
                  >
                    {label}
                  </Button>
                );
              }

              return (
                <Button
                  key={path}
                  component={NavLink}
                  to={path}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  {label}
                </Button>
              );
            })}

          </Box>

          <Menu
            anchorEl={anchorElBiography}
            open={Boolean(anchorElBiography)}
            onClose={handleBiographyClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            className='dropdownHeadernav'
          >
            {biographySubItems.map(({ label, hash }) => (
              <MenuItem
                key={hash}
                onClick={handleBiographyClose}
                component={Link}
                to={`/biography${hash}`}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>

        </Toolbar>
      </Container>
      {showScrollTop && (
        <Button
          onClick={scrollToTop}
          className='scrollTopbtn goTotop'
          variant="contained"
          size="small"
        >
          <StraightIcon />
        </Button>
      )}
    </AppBar>

  );

}

export default Header;

